module.exports = __webpack_public_path__ + "img/teaching-2.257e2916.png";